import { TypeOf } from 'io-ts';

import { codecFromArray } from '@dmb/core';

export const [DmbThemeC, dmbThemes] = codecFromArray(['standard', 'dark']);
export type DmbTheme = TypeOf<typeof DmbThemeC>;
